import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTASection: React.FC = () => {
  return (
    <section className="section bg-primary text-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-white">
            Ready to Grow Your Advisory Practice?
          </h2>
          <p className="text-lg sm:text-xl mb-8 text-white/90">
            Join hundreds of successful financial advisors who are growing their businesses with our platform.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/contact" className="btn bg-white text-primary hover:bg-gray-100">
              Schedule a Demo <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            <Link to="/pricing" className="btn border border-white/30 text-white hover:bg-white/10">
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;